import { base44 } from "@/api/base44Client";
import { shouldTrack } from "@/lib/pageTracking";

// Tracks a form completion or drop-off, tied to the page the form was on.
export function trackFormEvent(formName, completed) {
  shouldTrack().then((track) => {
    if (!track) return;
    base44.entities.ResourceEvent.create({
      page: window.location.pathname.replace(/\/$/, "") || "/",
      event_type: "click",
      element_label: completed ? "form_completion" : "form_dropoff",
      form_name: formName,
      session_id: `form-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    }).catch(() => {});
  });
}